export default "__VITE_ASSET__tlqHlYRf__"